import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import CustomImage from "@/app/components/common/Image";
import { IBanner } from "muminsmart-utils";
import type { CarouselApi } from "@/components/ui/carousel";

const AUTOPLAY_INTERVAL_MS = 3000;

interface BannerCarouselProps {
  banners: IBanner[];
}

const BannerCarousel = ({ banners }: BannerCarouselProps) => {
  const [api, setApi] = useState<CarouselApi>();

  useEffect(() => {
    if (!api) {
      return;
    }

    const interval = setInterval(() => {
      api.scrollNext();
    }, AUTOPLAY_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [api]);

  return (
    <Carousel
      opts={{ align: "start", loop: true }}
      setApi={setApi}
      className="w-full"
    >
      <CarouselContent>
        {banners.map((banner) => (
          <CarouselItem key={banner.id} className="basis-[90%] max-w-[90%]">
            <Link to={banner.link} className="w-full">
              <CustomImage
                src={banner.image}
                alt={banner.name}
                className="w-full h-auto rounded-2xl"
              />
            </Link>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

export default BannerCarousel;
